
import React from 'react';
import { connect } from 'react-redux';
import { getOrganizations } from '../Clients/ClientsAction';
import PropTypes from 'prop-types';
import { DropdownList } from 'react-widgets';

class OrganizationSelector extends React.Component {

  constructor(props) {
    super(props);
    //this.onChange = this.onChange.bind(this);
    this.state = {
      organizationId: this.props.organizationId,
      removeSelected: true,
      disabled: false,
      crazy: false,
      stayOpen: false,
      value: [],
      rtl: false
    };

    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
    this.toggleRtl = this.toggleRtl.bind(this);
  }

  componentDidMount() {
    this.props.getOrganizations();
  }

  handleSelectChange(value) {
    this.props.onChange(value);

  }
  toggleCheckbox(e) {
    this.setState({
      [e.target.name]: e.target.checked,
    });
  }
  toggleRtl(e) {
    let rtl = e.target.checked;
    this.setState({ rtl });
  }

  render() {



    const { value, disabled } = this.props;

    let options = [];
    this.props.organizations.forEach((value) => {
      options.push({ label: value.name, value: value._id });
    });

    return (

      <DropdownList
        disabled={disabled}

        id="client-select"
        name="selected-client"
        onChange={this.handleSelectChange}
        data={options}
        textField='label'
        valueField='value'
        placeholder="Select Clients."
        value={value}
      />


    );
  }
}

const mapStateToProps = (state) => ({
  organizations: state.clients.get('data') || []
});

const mapDisptatchToProps = (dispatch) => ({
  getOrganizations: () => dispatch(getOrganizations()),
});

OrganizationSelector.propTypes = {
  onChange: PropTypes.func,
  organizationId: PropTypes.string
};

OrganizationSelector.defaultProps = {
  onChange: () => true
};


export default connect(mapStateToProps, mapDisptatchToProps)(OrganizationSelector);


// WEBPACK FOOTER //
// ./src/containers/OrganizationSelector/OrganizationSelector.js